/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PeriodTimeEnum = {
    Week: 1,
    LastWeek: 2,
    Month: 3,
    LastMonth: 4,
    Year: 5,
    LastYear: 6
} as const;
export type PeriodTimeEnum = typeof PeriodTimeEnum[keyof typeof PeriodTimeEnum];


export function instanceOfPeriodTimeEnum(value: any): boolean {
    for (const key in PeriodTimeEnum) {
        if (Object.prototype.hasOwnProperty.call(PeriodTimeEnum, key)) {
            if (PeriodTimeEnum[key as keyof typeof PeriodTimeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PeriodTimeEnumFromJSON(json: any): PeriodTimeEnum {
    return PeriodTimeEnumFromJSONTyped(json, false);
}

export function PeriodTimeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PeriodTimeEnum {
    return json as PeriodTimeEnum;
}

export function PeriodTimeEnumToJSON(value?: PeriodTimeEnum | null): any {
    return value as any;
}

export function PeriodTimeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PeriodTimeEnum {
    return value as PeriodTimeEnum;
}

